import { PostCheckoutMandatoryQuestionsInAppVariant } from '../../../constants/statsig';
import { CheckoutState } from '../../../state';
import { getPostCheckoutMandatoryQuestionsInApp } from '../../../utils/statsig';
import {
    getIsOrganizationExcludedFromPostCheckoutMandatoryQuestions,
    isNativeApp,
} from '../../app';
import { isSalesClient } from '../../event';
import {
    getIsPostCheckoutMandatoryQuestionsSupported,
    hasOfflinePaymentMethods,
} from '../../order/typedOrderSelectors';
import { getHasInventoryQuestions } from './getHasInventoryQuestions';
import { getHasTaxQuestions } from './getHasTaxQuestions';
import { getHasWaiverQuestions } from './getHasWaiverQuestions';

export enum SurveyDistribution {
    onlyOptionalQuestionsAfterPayment = 'onlyOptionalQuestionsAfterPayment',
    cannedQuestionsAndOptionalQuestionsAfterPayment = 'cannedQuestionsAndOptionalQuestionsAfterPayment',
    allQuestionsAfterPayment = 'allQuestionsAfterPayment',
}

const surveyPageByQuestionRequirementStatusByPostCheckoutMandatoryQuestionsInAppVariant: Record<
    PostCheckoutMandatoryQuestionsInAppVariant,
    SurveyDistribution
> = {
    [PostCheckoutMandatoryQuestionsInAppVariant.optionalQuestionsInApp]:
        SurveyDistribution.onlyOptionalQuestionsAfterPayment,
    [PostCheckoutMandatoryQuestionsInAppVariant.optionalAndCannedQuestionsInApp]:
        SurveyDistribution.cannedQuestionsAndOptionalQuestionsAfterPayment,
    [PostCheckoutMandatoryQuestionsInAppVariant.customQuestionsInApp]:
        SurveyDistribution.allQuestionsAfterPayment,
};

/**
 * @private Do not use this directly, derive information from `getSurvey` instead
 */
export const getSurveyDistribution = (
    state: CheckoutState,
): SurveyDistribution => {
    const isDeferringRequiredQuestionsSupported =
        getIsPostCheckoutMandatoryQuestionsSupported(state) &&
        !hasOfflinePaymentMethods(state) &&
        !getHasTaxQuestions(state) &&
        !getHasWaiverQuestions(state) &&
        !getHasInventoryQuestions(state);

    const isOrganizerExplicitlyExcluded =
        isSalesClient(state) ||
        getIsOrganizationExcludedFromPostCheckoutMandatoryQuestions(state);

    if (
        !isDeferringRequiredQuestionsSupported ||
        isOrganizerExplicitlyExcluded
    ) {
        return SurveyDistribution.onlyOptionalQuestionsAfterPayment;
    }

    if (isNativeApp(state)) {
        const postCheckoutMandatoryQuestionsInAppVariant =
            getPostCheckoutMandatoryQuestionsInApp();

        return surveyPageByQuestionRequirementStatusByPostCheckoutMandatoryQuestionsInAppVariant[
            postCheckoutMandatoryQuestionsInAppVariant
        ];
    }

    return SurveyDistribution.allQuestionsAfterPayment;
};
